module.exports = __webpack_public_path__ + "img/m_home_trade.4fbc48db.png";